/** Freight groups delivered by a carrier, which cannot be sent to a store for collection. */
const FREIGHT_BY_CARRIER_GROUPS = ['C', 'D', 'E', 'F', 'G'];

/**
 * Takes the freight group rather than a product, so callers reading it under either the
 * Salesforce (`c_itemFreightGroup`) or Algolia (`cust_freight_group`) spelling can share this.
 */
export const isFreightByCarrier = (freightGroup: string | undefined) =>
    FREIGHT_BY_CARRIER_GROUPS.includes(freightGroup ?? '');
